<template>
	<div class="form-mdfpwd">

		<el-form ref="form" :model="form" label-width="" class="clearfix" @submit.native.prevent>
			<div class="pwdhead">
				<span class="pwdtitle">{{ThisActive.type == 'attrSpan' ? '属性看板' : ThisActive.DeviceName}}</span>
				<div class="closediv" @click="close"><span class="close"></span></div>
			</div>
			<div class="attr_body" v-if="ShowHTMLForType=='attrSpan'">
				<div class="overAuto">
					<div class="data-lab clearfix" v-for="(item,index) in dataBlock">
						<div class="box_name" :title="item.name+'/'+item.DeviceName">{{item.name}}</div>
						<div class="box_nameDevice" :title="item.name+'/'+item.DeviceName"> / {{item.DeviceName}} : </div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'int' || item.type == 'float' || item.type == 'double')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_config" @click="MdfClassify(item,'attrSpan')" v-if="$store.state.functionList.includes('companyServiceContrl') && item.accessMode=='rw' && !isLook && !item.loading">设定</div>
							<div class="content_value" :style="{'color':item.colorTip}">{{item.value}}&nbsp;{{item.unit}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'date' || item.type == 'text')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_config" @click="MdfClassify(item,'attrSpan')" v-if="$store.state.functionList.includes('companyServiceContrl') && item.accessMode=='rw' && !isLook && !item.loading">设定</div>
							<div class="content_value">{{item.value}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'bool')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_Mark"
								v-for="(itemData,index) in item.selectOptions"
								v-if="ifBybool(item,index)"
								:class="classBybool(item,index)"
								@click="ChangeAttr(item.DeviceCode,item.identifier,index,'Bool')"
								:title="itemData"
							>{{itemData}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'enum')">
							<el-select v-if="$store.state.functionList.includes('companyServiceContrl') && !isLook&&item.accessMode == 'rw'" popper-class="el-attrDiy" v-model="item.value" filterable placeholder="请选择" @change="(val)=>ChangeAttr(item.DeviceCode,item.identifier,val,'Enum')">
								<el-option v-for="(itemA,index) in item.selectOptions" :key="itemA.id" :label="itemA.name" :value="itemA.id">
								</el-option>
							</el-select>
							<div class="content_name">{{item.selectOptions.filter(i => i.id == Number(item.value))[0].name}}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="attr_body" v-if="ShowHTMLForType=='img'">
				<div class="overAuto">
					<div class="data-lab clearfix" v-for="(item,index) in dataBlock">
						<div class="box_name_Img" :title="item.name">{{item.name}} : </div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'int' || item.type == 'float' || item.type == 'double')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_config" @click="MdfClassify(item,'img')" v-if="$store.state.functionList.includes('companyServiceContrl') && item.accessMode=='rw' && !isLook && !item.loading">设定</div>
							<div class="content_value" :style="{'color':item.colorTip}">{{item.value}}&nbsp;{{item.unit}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'date' || item.type == 'text')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_config" @click="MdfClassify(item,'img')" v-if="$store.state.functionList.includes('companyServiceContrl') && item.accessMode=='rw' && !isLook && !item.loading">设定</div>
							<div class="content_value">{{item.value}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'bool')">
							<el-button class="content_config_loading" :loading="item.loading" v-if="item.loading"></el-button>
							<div class="content_Mark"
								v-for="(itemData,index) in item.selectOptions"
								v-if="ifBybool(item,index)"
								:class="classBybool(item,index)"
								@click="ChangeAttr(item.DeviceCode,item.identifier,index,'Bool')"
								:title="itemData"
							>{{itemData}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.value != null && (item.type == 'enum')">
							<el-select v-if="$store.state.functionList.includes('companyServiceContrl') && !isLook&&item.accessMode == 'rw'" popper-class="el-attrDiy" v-model="item.value" filterable placeholder="请选择" @change="(val)=>ChangeAttr(item.DeviceCode,item.identifier,val,'Enum')">
								<el-option v-for="(itemA,index) in item.selectOptions" :key="itemA.id" :label="itemA.name" :value="itemA.id">
								</el-option>
							</el-select>
							<div class="content_name">{{item.selectOptions.filter(i => i.id == Number(item.value))[0]?item.selectOptions.filter(i => i.id == Number(item.value))[0].name:""}}</div>
						</div>
					</div>
				</div>
			</div>
			<button type="button" @click="close()" class="ely-button closeto"><span>关闭</span></button>
		</el-form>

		<mdfClassify :ref="attr"></mdfClassify>
	</div>
</template>

<script>
	import mdfClassify from './MdfClassifyPreview.vue'
	import { mapMutations } from 'vuex';
	export default {
		name: 'mdfpwd',
		props: {
			type: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				MqttByDeviceUrl: '',//当前类型为关联设备时的subaru地址
				MqttByattrSpanUrl: [],//当前类型为属性看板时的subaru地址数组(多个)
				//退订时的回调
				MqttExitBackFunction: {
                    onSuccess(){
                        // console.log("退订成功")
                    },
                    onFailure(error){
                        // console.log("退订失败")
                        // console.log(error)
                    }
                },
				attr: 'mdfClassify',

				form: {},
				index: null,//用于关闭相应按钮
				ThisActive: {},

				ShowHTMLForType: '',//展示相应类型的html内容

				//属性看板
				dataBlock: [],
				//存放物模型字段
				PropertyValue: [],

				//测试字段
				ThisActiveMark: false,
				colorId: 1,
				conduitColorOptions: [{
					id: 1,
					name: '灰色',
				}, {
					id: 2,
					name: '红色',
				}, {
					id: 3,
					name: '蓝色',
				}],

				//产品物模型数组
				ProductFeature: [],
        companyId:null,
			}
		},
		computed: {
			isLook() {
				return this.$store.state.isLook;
			},
			ifBybool() {
				return (item,index) => {
					let returnD;
          if(!item.value&&item.value!=0){
            returnD=false
          }else{
            if(this.$store.state.isLook || !this.$store.state.functionList.includes('companyServiceContrl')){
            	if(Number(item.value) == index){
            		returnD = true
            	}else{
            		returnD = false
            	}
            }else{
            	if(item.loading){
            		if(Number(item.value) == index){
            			returnD = true
            		}else{
            			returnD = false
            		}
            	}else{
            		if(item.accessMode == 'rw'){
            			returnD = true
            		}else{
            			if(Number(item.value) == index){
            				returnD = true
            			}else{
            				returnD = false
            			}
            		}
            	}
            }
          }
					return returnD
				}
			},
			classBybool() {
				return (item,index) => {
					return {
						'leftThis': Number(item.value)==index&&!this.$store.state.isLook,
						'rightThis': Number(item.value)!=index&&!this.$store.state.isLook,
						'active': Number(item.value)!=index&&!this.$store.state.isLook,
						'UnCursor': Number(item.value)==index
					}
				}
			},
		},
		components: {
			mdfClassify
		},
		// mounted() {
		// 	var self = this;
		// 	/*按下*/
		// 	/*window.addEventListener('keydown', ev => {
		// 		ev = ev || event;
		// 		//空格按下
		// 		if(ev.keyCode == 27){
		// 			this.close();
		// 		}
		// 	})*/

		// },
		directives:{
			drag(el, bindings){
				let self = this;
				el.onmousedown = function(event){
					let evt = window.event || arguments[0];
					let startX = (evt.x || evt.clientX);
					let startY = (evt.y || evt.clientY);
					let DelX = startX - el.offsetLeft;
					let DelY = startY - (el.offsetTop + 74);//74为header高度
					//console.log(DelX,DelY)	//鼠标点击位于div的哪里
					const drag = () => {
						evt = window.event || arguments[0];
						let _x = (evt.x || evt.clientX);
						let _y = (evt.y || evt.clientY);


					}
					const up = () => {

						document.removeEventListener('mousemove', drag);
						document.removeEventListener('mouseup', up);
					}
					document.addEventListener('mousemove', drag);
					document.addEventListener('mouseup', up);
				}
			}
		},
		methods: {
			...mapMutations("defaultImgOptions", {
				ClickShowMarkUpdata: 'ClickShowMarkUpdata',
			}),
			//展开页面 绑定值
			binding(item) {
				let self = this;
        self.companyId = item.companyId
				return new Promise(async (resolve) => {
					this.ThisActive = item;
					this.index = item.index;
					this.dataBlock = [];
          // console.log(this.ThisActive)
					if(this.ThisActive.type == 'attrSpan'){
						/*属性看板*/
						this.ShowHTMLForType = 'attrSpan';
						await self.getAttrByTypeSpan();
						this.MqttattrSpanConnect(this.ThisActive.DeviceMoth);//开启关联设备mqtt连接
					}else{
						/*关联设备*/
						this.ShowHTMLForType = 'img';
						await self.getAttrByTypeImg();
						this.MqttDeviceConnect(this.ThisActive);//开启关联设备mqtt连接
					}
					self.UpdateDataColor();//通过值改变颜色
					self.$forceUpdate()/*强制刷新 略略略*/
					resolve();
					/*按下*/
					window.addEventListener('keydown', ev => {
						ev = ev || event;
						//esc按下
						if(ev.keyCode == 27){
              var now = new Date().getTime()
              if(!this.$store.state.Processing){
                this.close();
              }
						}
					})
				})
			},

			/*通过上下限值改变颜色*/
			UpdateDataColor(){
				for(let attrData of this.dataBlock){
					if(attrData.type == 'int' || attrData.type == 'float' || attrData.type == 'double'){
						let value = Number(attrData.value);
						attrData.colorTip = '#282828';
						if(attrData.warnDown != null&&attrData.warnDown!=""){
							let warnDown = Number(attrData.warnDown);
							if(value<=warnDown){
								attrData.colorTip = '#FF7E00';
							}
						}
						if(attrData.warnUp != null&&attrData.warnUp!=""){
							let warnUp = Number(attrData.warnUp);
							if(value>=warnUp){
								attrData.colorTip = '#FF7E00';
							}
						}
						if(attrData.errorDown != null&&attrData.errorDown!=""){
							let errorDown = Number(attrData.errorDown);
							if(value<=errorDown){
								attrData.colorTip = '#FF0000';
							}
						}
						if(attrData.errorUp != null&&attrData.errorUp!=""){
							let errorUp = Number(attrData.errorUp);
							if(value>=errorUp){
								attrData.colorTip = '#FF0000';
							}
						}
					}
				}
        this.$forceUpdate()
			},

			/*mqtt => (message)*/
			UpdateDataByMqtt(topic,message){
        // console.log(topic,this.ShowHTMLForType,JSON.parse(message.toString()))
				let self = this;
				if(this.ShowHTMLForType == 'img'){
					if(topic.split('/')[2] == this.ThisActive.DeviceCode){
						let items = JSON.parse(message.toString()).items;//转码
		                for(let a = 0; a < this.dataBlock.length; a++){
							if(items[this.dataBlock[a].identifier]||(items[this.dataBlock[a].identifier]==0)){
								if(this.dataBlock[a].type == 'enum'||this.dataBlock[a].type == 'bool'){
									this.dataBlock[a].value = Number(items[this.dataBlock[a].identifier])
								}else if(this.dataBlock[a].type == 'date'){
									this.dataBlock[a].value = self.changeTimeY(Number(items[this.dataBlock[a].identifier]))
								}else if(this.dataBlock[a].type == 'text'){
									this.dataBlock[a].value = items[this.dataBlock[a].identifier]
								}else{
									if(this.dataBlock[a].blockName == '虚拟设备'){
										this.dataBlock[a].value = self.common.fmoney(Number(items[this.dataBlock[a].identifier]));
									}else{
										this.dataBlock[a].value = self.common.fmoney(Number(items[this.dataBlock[a].identifier]),this.dataBlock[a].step);
									}
								}
							}
						}
					}
				}else if(this.ShowHTMLForType == 'attrSpan'){
					let item = JSON.parse(message.toString());//转码
					for(let a = 0; a < this.dataBlock.length; a++){
						if(this.dataBlock[a].DeviceCode == item.deviceCode){
							if(item.items[this.dataBlock[a].identifier]||(item.items[this.dataBlock[a].identifier]==0)){
								if(this.dataBlock[a].type == 'enum'||this.dataBlock[a].type == 'bool'){
									this.dataBlock[a].value = Number(item.items[this.dataBlock[a].identifier])
								}else if(this.dataBlock[a].type == 'date'){
									this.dataBlock[a].value = self.changeTimeY(Number(item.items[this.dataBlock[a].identifier]))
								}else if(this.dataBlock[a].type == 'text'){
									this.dataBlock[a].value = item.items[this.dataBlock[a].identifier]
								}else{
									if(this.dataBlock[a].blockName == '虚拟设备'){
										this.dataBlock[a].value = self.common.fmoney(Number(item.items[this.dataBlock[a].identifier]));
									}else{
										this.dataBlock[a].value = self.common.fmoney(Number(item.items[this.dataBlock[a].identifier]),this.dataBlock[a].step);
									}
								}
							}
						}
					}
				}
				this.UpdateDataColor();//通过值改变颜色
			},

			/*mqtt => 属性看板*/
			MqttattrSpanConnect(DeviceMoth){
				//console.log(DeviceMoth);
				for(let obj of DeviceMoth){
					let url;
					if(obj.DeviceName == '虚拟设备'){
						url = 'sys/virtual/' + obj.DeviceCode + '/property/push'
					}else{
						url = 'sys/device/' + obj.DeviceCode + '/property/push'
					}
					if(this.MqttByattrSpanUrl.filter(item => item == url).length == 0){
						this.$store.state.subaru.subscribe(url, { qos: 1 })
						this.MqttByattrSpanUrl.push(url)
					}
				}
			},

			/*mqtt => 关联设备*/
			MqttDeviceConnect(item){
				if(item.DeviceName == '虚拟设备'){
					// 订阅主题
					this.MqttByDeviceUrl = 'sys/virtual/' + item.DeviceCode + '/property/push';
				}else{
					// 订阅主题
					this.MqttByDeviceUrl = 'sys/device/' + item.DeviceCode + '/property/push';
				}
        // console.log("subscribe",this.MqttByDeviceUrl)
	      this.$store.state.subaru.subscribe(this.MqttByDeviceUrl, { qos: 1 })
			},
      /*接收mqtt*/
      getMqttMessage() {
      	// 接收消息处理
      	this.$store.state.subaru.on('message', (topic, message) => {
      		// console.log(topic);
      		if(topic.indexOf('/property/push') != -1) {
      			this.UpdateDataByMqtt(topic,message)
      		}
      	})
      },
			/*通过 设备Code/属性code 获取物模型对象*/
			getProductFeature(deviceCode, propertyCode) {
				/* 同步
				 * deviceCode => 设备code
				 * propertyCode => 属性code
				 * 返回物模型对象
				 * 如果属性Code存在 则返回属性Code对应的物模型属性对象
				 * */
				let self = this;
				return new Promise((resolve) => {
					let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
					if(FeatureArr.length == 0){
						if(this.type == 'mobile'){
							self.wx_get('/ProductFeature/getByDeviceCode', {
								code: deviceCode, //设备code
							}).then((resPro) => {
								if(resPro.success == true) {
									let dataList = JSON.parse(resPro.result).properties;
									self.ProductFeature.push({
										deviceCode: deviceCode,
										properties: dataList
									})
									if(propertyCode){
										resolve(dataList.filter(item => item.identifier == propertyCode)[0])
									}else{
										resolve(dataList)
									}
									return;
								}
							})
						}else{
							self.get('/ProductFeature/getByDeviceCode', {
								code: deviceCode, //设备code
							}).then((resPro) => {
								if(resPro.success == true) {
									let dataList = JSON.parse(resPro.result).properties;
									self.ProductFeature.push({
										deviceCode: deviceCode,
										properties: dataList
									})
									if(propertyCode){
										resolve(dataList.filter(item => item.identifier == propertyCode)[0])
									}else{
										resolve(dataList)
									}
									return;
								}
							})
						}
					}else{
						if(propertyCode){
							resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
						}else{
							resolve(FeatureArr[0].properties)
						}
						return;
					}
				})
			},

			/*type为 attrSpan时 定义dataBlock*/
			getAttrByTypeSpan(){
				let self = this;
				let ThisActive = this.ThisActive;
				return new Promise(async (resolve) => {
					let index = 0;
					for(let Device of ThisActive.DeviceMoth){
						await self.getAttrPushDataBlock(Device);
						index++;
						if(index == ThisActive.DeviceMoth.length){
							resolve();
						}
					}

				})
			},

			/*格式化value值
			 * value => 当前值
			 * type => 当前类型
			 * step => 当前设置的步长
			 * return => 返回根据格式处理的value
			 */
			initValue(value,type,step){
				let self = this;
				/*featureList.dataType.type == 'int' ? self.common.fmoney(Math.floor(Number(value))) : featureList.dataType.type == 'enum' || featureList.dataType.type == 'bool' ? Number(value) : self.common.fmoney(Number(value),featureList.dataType.specs.step)*/
				let returnValue;
				if(value == null) return null
				if(type == 'int'){
					returnValue = self.common.fmoney(Math.floor(Number(value)));
				}else if(type == 'enum' || type == 'bool'){
					returnValue = Number(value)
				}else if(type == 'date'){
					returnValue = self.changeTimeY(Number(value))
				}else if(type == 'text'){
					returnValue = value
				}else{
					returnValue = self.common.fmoney(Number(value),step)
				}
				return returnValue
			},

			/*传入一个设备对象 包含 选中的属性数组 (type => attrSpan)*/
			getAttrPushDataBlock(DeviceObj){
				let self = this;
				return new Promise((resolve) => {
					if(DeviceObj.DeviceName == '虚拟设备'){
						/*获取虚拟设备*/
						self.get('/VirtualDevice/get', {
							companyId: self.companyId
						}).then((res) => {
							if(res.success == true) {
								/*获取虚拟设备属性列表*/
								if(!DeviceObj.DeviceId&&DeviceObj.DeviceId!=0){ return }
								self.get('/VirtualDevice/getPropertyList', {
									deviceId: DeviceObj.DeviceId
								}).then((resAttr) => {
									if(resAttr.success == true) {
										/*获取虚拟设备属性值列表*/
										self.get('/VirtualDevice/getPropertyValue',{
											deviceId: DeviceObj.DeviceId
										}).then((resPro) => {
											if(resPro.success == true) {
												for(let list of resAttr.result){
													for(let value of resPro.result){
														if(list.code == value.code){
															let obj = {
																id: list.code,//标识符
																blockName: '虚拟设备',
																index: list.code + '-' + DeviceObj.DeviceCode,//唯一标识符 用于判断是否已经加载过
																type: 'float',//数据类型
																NumberId: list.id,//id
																identifier: list.code,//标识符
																DeviceCode: DeviceObj.DeviceCode,//设备code
																name: list.name,//名字
																unit: list.unit,//单位
                                DeviceName: '虚拟设备',//设备名字
																errorDown: list.errorDown,//属性值下下限
																errorUp: list.errorUp,//属性值上上限
																warnDown: list.warnDown,//属性值下限
																warnUp: list.warnUp,//属性值上限
																accessMode: 'r',//属性值的可读写状态 r rw
																// value: self.common.fmoney(Number(value.value)),//属性值
																loading: false,//当前加载中的状态
															}
                              if(value.value==0||value.value){
                                obj.value =  self.common.fmoney(Number(value.value))
                              }
															if(self.dataBlock.filter(item => item.index == obj.index).length == 0){
																if(obj.accessMode == 'rw'){
																	self.dataBlock.unshift(obj)
																}else{
																	self.dataBlock.push(obj)
																}
															}
														}
													}
												}
												resolve()
											}
										})
									}
								})
							}
						})
					}else{
						/*获取设备属性列表*/
						self.get('/Device/getPropertyValue', {
							deviceId: DeviceObj.DeviceId
						}).then(async (resAttr) => {
							if(resAttr.success == true) {
								//var valueList = resAttr.result;
								/*获取对应设备的物模型*/
								let dataList = await self.getProductFeature(DeviceObj.DeviceCode)
								let attrList = DeviceObj.attrData;
								let rwboolArr = [];
								let rwArr = [];
								let rboolArr = [];
								let rArr = [];
								for(let attr of attrList){
									for(let featureList of dataList) {
										if(featureList.identifier == attr.identifier) {
											let selectOptions = [];
											if(featureList.dataType.type == 'enum'){
												Object.keys(featureList.dataType.specs).forEach(function(key){
					                                let devObj ={};
					                                devObj.id = Number(key);
					                                devObj.name = featureList.dataType.specs[key];
					                                selectOptions.push(devObj);
					                            });
											}
											let value = null;
											if(resAttr.result.length != 0){
												if(resAttr.result.filter(item => item.code == featureList.identifier).length != 0){
													value = resAttr.result.filter(item => item.code == featureList.identifier)[0].value
												}
											}
											let obj = {
												id: featureList.identifier,//标识符
												identifier: featureList.identifier,//标识符
												index: featureList.identifier + '-' + DeviceObj.DeviceCode,//唯一标识符 用于判断是否已经加载过
												DeviceCode: DeviceObj.DeviceCode,//设备code
												name: featureList.name,//属性名字
												DeviceName: DeviceObj.DeviceName,//设备名字
												unit: featureList.dataType.specs.unit,//单位
												max: featureList.dataType.specs.max,//属性值可输入的最大值
												min: featureList.dataType.specs.min,//属性值可输入的最小值
												errorDown: featureList.dataType.errorDown,//属性值下限
												errorUp: featureList.dataType.errorUp,//属性值上限
												warnDown: featureList.dataType.warnDown,//属性值下下限
												warnUp: featureList.dataType.warnUp,//属性值上上限
												step: featureList.dataType.specs.step,//属性值的步长
												type: featureList.dataType.type,//属性值的数据类型
												accessMode: featureList.accessMode,//属性值的可读写状态 r rw
												// value: self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step),//属性值
												date: value,
												selectOptions: featureList.dataType.type == 'enum' ? selectOptions : featureList.dataType.specs,//如果为枚举 布尔 赋值options
												loading: false,//当前加载中的状态
											}
                      if(value==0||value){
                        obj.value = self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step)
                      }
											if(self.dataBlock.filter(item => item.index == obj.index).length == 0){
												if(obj.accessMode == 'rw'){
													if(obj.type == 'bool'){
														rwboolArr.push(obj)
													}else{
														rwArr.push(obj)
													}
												}else{
													if(obj.type == 'bool'){
														rboolArr.push(obj)
													}else{
														rArr.push(obj)
													}
												}
											}
										}
									}
								}
								self.dataBlock = self.dataBlock.concat(rwboolArr)
								self.dataBlock = self.dataBlock.concat(rwArr)
								self.dataBlock = self.dataBlock.concat(rboolArr)
								self.dataBlock = self.dataBlock.concat(rArr)
								resolve()
							}else{
								resolve()
							}
						})
					}

				})
			},

			/*type为 img时 定义dataBlock*/
			getAttrByTypeImg(){
				let self = this;
				return new Promise((resolve) => {
					if(self.ThisActive.DeviceName == '虚拟设备'){
						/*获取虚拟设备*/
						self.get('/VirtualDevice/get', {
							companyId: self.companyId
						}).then((res) => {
							if(res.success == true) {
								self.ThisActive.DeviceName = '虚拟设备';
								/*获取虚拟设备属性列表*/
								if(!self.ThisActive.DeviceId&&self.ThisActive.DeviceId!=0){ return }
								self.get('/VirtualDevice/getPropertyList', {
									deviceId: self.ThisActive.DeviceId
								}).then((resAttr) => {
									if(resAttr.success == true) {
										/*获取虚拟设备属性值列表*/
										self.get('/VirtualDevice/getPropertyValue',{
											deviceId: self.ThisActive.DeviceId
										}).then((resPro) => {
											if(resPro.success == true) {
												for(let list of resAttr.result){
													for(let value of resPro.result){
														if(list.code == value.code){
															let obj = {
																id: list.code,//标识符
																blockName: '虚拟设备',
																type: 'float',//数据类型
																NumberId: list.id,//id
																identifier: list.code,//标识符
																index: list.code + '-' + self.ThisActive.DeviceCode,//唯一标识符 用于判断是否已经加载过
																DeviceCode: self.ThisActive.DeviceCode,//设备code
																name: list.name,//名字
																unit: list.unit,//单位
																errorDown: list.errorDown,//属性值下下限
																errorUp: list.errorUp,//属性值上上限
																warnDown: list.warnDown,//属性值下限
																warnUp: list.warnUp,//属性值上限
																accessMode: 'r',//属性值的可读写状态 r rw
																// value: self.common.fmoney(Number(value.value)),//属性值
																loading: false,//当前加载中的状态
															}
                              if(value.value==0||value.value){
                                obj.value =  self.common.fmoney(Number(value.value))
                              }
															if(self.dataBlock.filter(item => item.index == obj.index).length == 0){
																if(obj.accessMode == 'rw'){
																	self.dataBlock.unshift(obj)
																}else{
																	self.dataBlock.push(obj)
																}
															}
														}
													}
												}
												resolve()
											}else{
												resolve()
											}
										})
									}
								})
							}
						})
					}else{
						/*获取设备*/
						self.get('/Device/get', {
							id: self.ThisActive.DeviceId
						}).then((res) => {
							if(res.success == true) {
								let attrList = res.result.propertySet.split(',');//属性列表
								self.ThisActive.DeviceName = res.result.name;
								/*获取设备属性列表*/
								self.get('/Device/getPropertyValue', {
									deviceId: self.ThisActive.DeviceId
								}).then(async (resAttr) => {
									if(resAttr.success == true) {
										//var valueList = resAttr.result;
										/*获取对应设备的物模型*/
										let dataList = await self.getProductFeature(res.result.code)
										let rwboolArr = [];
										let rwArr = [];
										let rboolArr = [];
										let rArr = [];
										for(let attr of attrList){
											for(let featureList of dataList) {
												if(featureList.identifier == attr) {
													let selectOptions = [];
													if(featureList.dataType.type == 'enum'){
														Object.keys(featureList.dataType.specs).forEach(function(key){
							                                let devObj ={};
							                                devObj.id = Number(key);
							                                devObj.name = featureList.dataType.specs[key];
							                                selectOptions.push(devObj);
							                            });
													}
													let value = null;
													if(resAttr.result.length != 0){
														if(resAttr.result.filter(item => item.code == featureList.identifier).length != 0){
															value = resAttr.result.filter(item => item.code == featureList.identifier)[0].value
														}
													}
													let obj = {
														id: featureList.identifier,//标识符
														identifier: featureList.identifier,//标识符
														index: featureList.identifier + '-' + res.result.code,//唯一标识符 用于判断是否已经加载过
														DeviceCode: res.result.code,//设备code
														name: featureList.name,//名字
														unit: featureList.dataType.specs.unit,//单位
														max: featureList.dataType.specs.max,//属性值可输入的最大值
														min: featureList.dataType.specs.min,//属性值可输入的最小值
														errorDown: featureList.dataType.errorDown,//属性值下下限
														errorUp: featureList.dataType.errorUp,//属性值上上限
														warnDown: featureList.dataType.warnDown,//属性值下限
														warnUp: featureList.dataType.warnUp,//属性值上限
														step: featureList.dataType.specs.step,//属性值的步长
														type: featureList.dataType.type,//属性值的数据类型
														accessMode: featureList.accessMode,//属性值的可读写状态 r rw
														// value: self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step),//属性值
														selectOptions: featureList.dataType.type == 'enum' ? selectOptions : featureList.dataType.specs,//如果为枚举 布尔 赋值options
														date: value,
														loading: false,//当前加载中的状态
													}
                          if(value==0||value){
                            obj.value = self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step)
                          }
													if(self.dataBlock.filter(item => item.index == obj.index).length == 0){
														if(obj.accessMode == 'rw'){
															if(obj.type == 'bool'){
																rwboolArr.push(obj)
															}else{
																rwArr.push(obj)
															}
														}else{
															if(obj.type == 'bool'){
																rboolArr.push(obj)
															}else{
																rArr.push(obj)
															}
														}
													}
												}
											}
										}
										self.dataBlock = self.dataBlock.concat(rwboolArr)
										self.dataBlock = self.dataBlock.concat(rwArr)
										self.dataBlock = self.dataBlock.concat(rboolArr)
										self.dataBlock = self.dataBlock.concat(rArr)
                    // console.log(self.dataBlock)
										resolve();
									}else{
										resolve();
									}
								})
							}
						})
					}
				})
			},

			/*改变选中值 统一*/
			ChangeAttr(DeviceCode, AttrCode, value, type){
				/*
				 * 该方法为属性看板与设备属性 type为枚举和布尔型时的修改方法
				 * DeviceCode => 设备code
				 * AttrCode => 属性Code
				 * value => 当前选中的options数组的value
				 * type => 枚举传入Enum 布尔传入Bool
				 */
				if(type == 'Bool'){
					if(value == Number(this.dataBlock.filter(item => (item.DeviceCode == DeviceCode) && (item.identifier == AttrCode))[0].value))return;
				}
				let obj = {
					deviceCode: DeviceCode,
					property: AttrCode,
					value: value,
					companyId: this.companyId
				}
				this.dataBlock.filter(item => (item.DeviceCode == DeviceCode) && (item.identifier == AttrCode))[0].loading = true;
				this.post('/Device/setPropertyValue',obj).then((res)=>{
	                if(res.success){
	                    this.$message({
					        showClose: true,
	                        message: '修改属性成功',
	                        type: 'success'
	                    });
	                    //this.dataBlock.filter(item => (item.DeviceCode == DeviceCode) && (item.identifier == AttrCode))[0].value = value;
						this.dataBlock.filter(item => (item.DeviceCode == DeviceCode) && (item.identifier == AttrCode))[0].loading = false;
	                    this.$forceUpdate()/*强制刷新 略略略*/
	                }else{
	                    this.$message({
					        showClose: true,
	                        message: `错误码 : ${res.result} ${res.message?res.message:''}`,
	                        type: 'warning'
	                    });
						this.dataBlock.filter(item => (item.DeviceCode == DeviceCode) && (item.identifier == AttrCode))[0].loading = false;
	                }
	            })
			},

			/*切换修改值的loading状态*/
			loadingUpdate(code){
				this.dataBlock.filter(item => item.id == code)[0].loading = !this.dataBlock.filter(item => item.id == code)[0].loading;
				this.$forceUpdate();
			},

			//更新所选属性的值
			AttrDataUpdata(id,val,type){
				for(let data of this.dataBlock){
					if(data.id == id){
						data.value = val;
						data.colorTip = '#282828';
						let value = Number(val)
						if(data.warnDown != null&&data.warnDown != ""){
							let warnDown = Number(data.warnDown);
							if(value<=warnDown){
								data.colorTip = '#FF0000';
							}
						}
						if(data.warnUp != null&&data.warnUp != ""){
							let warnUp = Number(data.warnUp);
							if(value>=warnUp){
								data.colorTip = '#FF0000';
							}
						}
						if(data.errorDown != null&&data.errorDown != ""){
							let errorDown = Number(data.errorDown);
							if(value<=errorDown){
								data.colorTip = '#FF7E00';
							}
						}
						if(data.errorUp != null&&data.errorUp != ""){
							let errorUp = Number(data.errorUp);
							if(value>=errorUp){
								data.colorTip = '#FF7E00';
							}
						}
					}
				}
			},

			close() {
				this.dataBlock = [];
				this.ShowHTMLForType = '';
				this.$parent.showData('close');
				/*切换看板颜色*/
				if(this.ThisActive.type == 'attrSpan'){
					this.$emit('changeattrSpan',this.ThisActive.index)
				}

				/*断开mqtt*/
				if(this.MqttByDeviceUrl != ''){
					this.$store.state.subaru.unsubscribe(this.MqttByDeviceUrl,this.MqttExitBackFunction)
				}else{
					for(let url of this.MqttByattrSpanUrl){
						this.$store.state.subaru.unsubscribe(url,this.MqttExitBackFunction)
					}
				}
				this.MqttByDeviceUrl = '';
				this.MqttByattrSpanUrl = [];
			},
			MdfClassify(item) {
				var self = this;
        let VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
        // console.log(VerifyArr)
				if(VerifyArr.includes(12)){
					this.$parent.functionShow = true;
          // this.$store.state.mask=true
					return
				}
				if(this.$refs.mdfClassify.$el.style.display == "" || this.$refs.mdfClassify.$el.style.display == "none") {
					this.$refs.mdfClassify.binding(item);
					this.$refs.mdfClassify.$el.style.display = "block";
					setTimeout(function() {
						self.$refs.mdfClassify.$el.style.opacity = 1;
						self.$refs.mdfClassify.$children[0].$el.style.top = 0 + 'px';
					}, 50)
				} else {
					this.$refs.mdfClassify.$el.style.opacity = 0;
					self.$refs.mdfClassify.$children[0].$el.style.top = -50 + 'px';
					setTimeout(function() {
						self.$refs.mdfClassify.$el.style.display = "none";
					}, 100)
				}
			},
		}
	}
</script>

<style scoped>
	.UnCursor{
		cursor: unset !important;
	}
	.rightThis{
		float: right !important;
	    max-width: 60px;
	    display: block;
	    overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	}
	.leftThis{
		float: left !important;
	}
	.content_name{
        float: right;
	    max-width: 66px;
	    /* cursor: pointer; */
	    /* line-height: 19px; */
	    /* padding: 2px 12px; */
	    border-radius: 12px;
	    color: #282828;
	    /* margin-top: 13px; */
	    font-size: 13px;
	    transition: .1s;
	    margin-right: 10px;
	}
	.backMessage {
		background-color: #363738 !important;
		border: 0px !important;
	}

	.backMessage .el-message__content {
		color: #DADADA !important;
	}

	.backMessage .el-message__icon.el-icon-success {
		color: #DADADA !important;
	}

	.el-attrDiy .el-select-dropdown__item.selected{
		color: #5087e4;
		font-weight: unset;
	}
	.el-attrDiy .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
		background-color: #F5F7FA;
	}
	.box_content>>>.el-input .el-input__icon{
		    height: 40px;
    width: 25px;
	}
	.box_content>>>.el-input__inner{
		border: 0px;
	}
	.box_content>>>.el-input{
		/*margin-left: 38px;
		width: 75%;*/
	}
	.attr_body {
		height: 560px;
	    position: relative;
	    /* display: flex; */
	    width: 100%;
	}

	.box_content>>>.el-switch.is-checked .el-switch__core::after {
		left: 100%;
		margin-left: -17px;
	}

	.box_content>>>.el-switch__core:after {
		width: 18px;
		height: 18px;
		top: 0px;
		left: 0px;
	}

	.box_content>>>.el-switch__core {
		border: 1px solid #757575;
		background: #141414;
	}

	.box_content>>>.el-switch.is-checked .el-switch__core {
		border-color: #2571EF;
		background-color: #2571EF;
	}

	.content_value {
	    float: right;
	    /*max-width: 95px;*/
	    margin-right: 10px !important;
	    color: #282828;
	}

	.content_config {
		float: right;
		max-width: 66px;
		cursor: pointer;
		line-height: 19px;
		padding: 2px 12px;
		border-radius: 12px;
		background-color: #5087e4;
		color: #fff;
		margin-top: 13px;
		font-size: 12px;
	}
	.content_config_loading{
		float: right;
		max-width: 66px;
		cursor: pointer;
		line-height: 19px;
		padding: 2px 12px;
		border-radius: 12px;
		background-color: #5087e4;
		color: #fff;
		margin-top: 13px;
		font-size: 12px;
	    min-width: 48px;
	    border: 0px;
	}
	.content_Mark {
		/*float: right;*/
		/*max-width: 66px;*/
		cursor: pointer;
		line-height: 19px;
		padding: 2px 12px;
		border-radius: 12px;
		color: #282828;
		margin-top: 13px;
		font-size: 14px;
		/*transition: .1s;*/
	}

	.content_Mark.active {
		color: #fff;
		background-color: #5087e4;
	}

	.box_content {
		float: right;
	    /*width: 130px;*/
	}

	.box_name {
		float: left;
		/*width: 110px;*/
		overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	    margin-right: 5px;
	}
	.box_name_Img {
		float: left;
		width: 115px;
	    overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	}
	.box_nameDevice{
		float: left;
		/*width: 60px;*/
		overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	}
	.history-data {
		float: right;
		color: #5087E4;
		font-size: 14px;
		margin-top: 24px;
		cursor: context-menu;
		cursor: pointer;
		position: relative;
		right: 22px;
	}

	.data-lab:nth-last-child(1),
	.data-lab:nth-last-child(2) {
		border-bottom: 1px solid #e6e6e6;
	}

	.data-lab {
		width: calc(100%/2 - 15px);
		text-align: left;
		padding: 0 14px;
		line-height: 48px;
		-webkit-box-sizing: border-box;
		/* box-sizing: border-box; */
		font-size: 14px;
		border: 1px solid #e6e6e6;
		border-bottom: 0;
		float: left;
	}

	.fileImgShow {
		background-position: left top;
		background-repeat: no-repeat;
	}

	.connectPoint {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: 10px;
		height: 10px;
		background-color: #5087E4;
		border-radius: 50%;
		line-height: 11px;
		font-size: 12px;
		color: #fff;
		margin-left: -5px;
		margin-top: -5px;
	}

	.connectPoint div {
		transform: scale(.8);
		position: relative;
		left: 0px;
	}
	/*滚动条样式：谷歌浏览器下*/

	.overAuto::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #f5f7fa;
	}
	/*滚动条的轨道*/

	.overAuto::-webkit-scrollbar-track {
		/*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
		background-color: #fff;
	}
	/*滚动条的滑块按钮*/

	.overAuto::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #C2C2C2;
		/*box-shadow: inset 0 0 5px #000;*/
	}
	/*滚动条的上下两端的按钮*/

	.overAuto::-webkit-scrollbar-button {
		height: 0px;
		/*background-color: #B0AEDA;*/
		width: 0px;
	}
	.overAuto {
	    width: 100%;
	    max-height: 477px;
	    overflow: auto;
	    display: flex;
	    justify-content: space-between;
	    flex-direction: row;
	    flex-wrap: wrap;
	    position: absolute;
	}

	.overAuto .data-lab:nth-child(odd) {
		margin-right: 15px;
	}

	.blueSpan {
		cursor: pointer !important;
		color: #5087E4 !important;
	}

	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix i {
		line-height: 34px;
	}

	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix input {
		height: 34px;
		border-radius: 0;
		line-height: 34px;
		/* padding: 0 !important; */
		margin: 0 !important;
	}

	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix {
		height: 34px;
	}

	.el-form>>>.bottom__ .el-select {
		width: 140px;
		height: 34px;
		float: left;
	}

	.top_box .ljd_name {
		margin-right: 36px !important;
	}

	.top_box .ljd_name,
	.ljd_cx {
		line-height: 34px;
		font-size: 14px;
		margin-right: 13px;
		float: left;
	}

	.top_box .ljd_sc {
		line-height: 34px;
		font-size: 14px;
		float: left;
		margin-left: 12px;
	}

	.el-form>>>.el-input-number__decrease,
	.el-form>>>.el-input-number__increase {
		display: none;
	}

	.el-form>>>.el-input-number {
		float: left;
		width: 57px;
		margin-top: -2px;
	}

	.errorLight {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}

	.el-form>>>.el-textarea__inner {
		border-radius: 0px !important;
	}

	.top_content .title {
		float: left;
		width: 60px;
		line-height: 34px;
	}

	.top_content .positionXY {
		float: left;
		width: 77px;
		margin-right: 21px;
	}

	.top_content .positionXY span {
		float: left;
		line-height: 34px;
		margin-right: 12px;
	}

	.el-form>>>.top_content .positionXY .el-input {
		float: left;
		width: 57px;
		height: 34px;
	}

	.el-form>>>.top_content .positionXY .el-input input {
		height: 34px;
		border-radius: 0px;
		text-align: center;
		width: 100%;
		padding: 0;
	}

	.el-form>>>.el-checkbox {
		float: left;
		width: 30%;
		line-height: 34px;
	}

	.top_content.active {
		color: #393939;
	}

	.top_content {
		width: 70%;
		float: left;
		color: #C2C2C2;
		transition: .3s;
	}

	.bottom__ .top_content {
		width: 220px;
		float: left;
		color: #393939;
		margin-left: 25px;
	}

	.bottom__ .top_content .title {
		width: 45px;
	}

	.top_box {
		width: 100%;
		float: left;
		margin-bottom: 8px;
		text-align: left;
	}

	.top__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
	}

	.bottom__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
	}

	.content_right .right_ {
		float: left;
		width: 100%;
		position: relative;
	}

	.top__ {
		margin-top: 25px;
	}

	.bottom__ {
		margin-top: 45px;
	}

	.content_right {
		width: 553px;
		float: left;
		position: relative;
	}

	.el-form-item__errorMy.active {
		opacity: 1;
		transform: scaleY(1);
	}

	.el-form-item__errorMy {
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
		position: absolute;
		top: 100%;
		left: 0;
		transition: .3s;
		opacity: 0;
		transform: scaleY(0);
	}

	.classifyOpa {
		font-weight: unset !important;
	}

	.test-box {
		position: absolute;
		width: 20px;
		height: 20px;
		background-color: red;
		border-radius: 50%;
	}

	.fileImgShow {
		position: absolute;
		left: -21px;
		right: 0;
		bottom: 0;
		top: 0px;
		margin: auto;
		width: 173px;
		height: 197px;
	}

	.position_xyzImg {
		position: absolute;
		right: 4px;
		bottom: 11px;
	}

	.position_xyImg {
		position: absolute;
		left: 4px;
		top: 4px;
	}

	.position_body {
		position: relative;
		width: 292px;
		background: rgba(245, 245, 245, 1);
		height: 237px;
		cursor: pointer;
		float: left;
		margin-top: 3px;
		overflow: hidden;
	}

	.file_img p {
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
		font-size: 14px;
	}

	.file_img .file_img_span {
		cursor: pointer;
		color: #5087E4;
		top: 0;
		position: relative;
		float: left;
		width: 100%;
		text-align: left;
		left: 45px;
		top: 2.5px;
	}

	.file_img {
		float: left;
		width: 100%;
		/* padding-top: 24px; */
		margin-top: -40px;
	}

	.content_left {
		float: left;
		width: 582px;
		position: relative;
	}

	.form-mdfpwd {
		width: 100%;
		height: 100%;
		display: none;
		background: rgba(0, 0, 0, .4);
		position: absolute;
		top: 0px;
		bottom: 0;
		left: 0px;
		right: 0;
		z-index: 9999999;
		margin: auto;
		opacity: 0;
		transition: .2s;
	}

	.el-form {
		display: block;
		width: 886px;
    	height: 630px;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 74px;
		top: -50px;
		transition: .2s;
		background-color: #fff;
		border-radius: 1px;
		padding-left: 34px;
		padding-right: 30px;
	}

	.pwdhead {
		width: 100%;
		height: 63px;
		/*border-bottom: 1px solid #efefef;*/
	}

	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 15px;
		margin-left: -2px;
		margin-top: 22px;
		cursor: context-menu;
	}

	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: -9px;
		margin-top: 18px;
		width: 30px;
		height: 30px;
		cursor: pointer;
	}

	.pwdhead .close {
		float: right;
		position: relative;
		width: 1px;
		height: 16px;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 8px;
		right: 15px;
	}

	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 1px;
		height: 16px;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}

	.el-form-item {
		margin: 0;
		/* padding-left: 13px; */
		padding-top: 24px;
	}

	.el-form-item>>>.el-form-item__label {
		float: left;
		width: 100%;
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
	}

	.el-form-item>>>.el-form-item__content {
		float: left;
		width: 494px;
	}

	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 15px !important;
		/*border: 1px solid rgba(222, 222, 222, 1) !important;*/
		border-radius: 0px;
	}

	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		width: 86px;
		letter-spacing: 1px;
		margin-top: 18px;
		font-size: 13px;
		cursor: pointer;
		border: 0;
		border-radius: 2px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		left: 0px;
		right: 0;
		bottom: 28px;
		margin: auto;
		margin-top: 23px;
	}
	.el-form>>>.el-select {
	    width: 98px;
	    float: right;
	}
	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/preview/attrBlackBoard/AttrBlackboard.vue